import { Directive, HostListener, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { UserDetailsStore } from '@store';

import { ChangeUserDetailsModalComponent } from './change-user-details-modal/change-user-details-modal.component';

@Directive({
  selector: '[appChangeUserDetails]',
  standalone: true,
})
export class ChangeUserDetailsDirective {
  changeUserDetailsModalRef: MatDialogRef<ChangeUserDetailsModalComponent>;

  @Input() appChangeUserDetails: 'personal' | 'address' | 'contact' | 'other' = 'personal';

  @HostListener('click')
  onClick(): void {
    this.userDetailsStore.initUserDetailsChange();
    this.changeUserDetailsModalRef = this.matDialog.open(ChangeUserDetailsModalComponent, {
      width: '552px',
      panelClass: 'new-user-dialog',
      disableClose: true,
      data: {
        changeType: this.appChangeUserDetails,
      },
    });
  }

  constructor(private matDialog: MatDialog, private userDetailsStore: UserDetailsStore) {}
}
